/**
 * Hook to initialize and verify the session on app mount.
 *
 * Runs once whenever status is 'loading' (i.e. a token exists in localStorage).
 * Calls getAccount() to validate the token with cloud-api and populates the
 * session store. If the token is invalid or expired, clears the session.
 */
import { useEffect } from 'react';
import { getAccount, listProjects } from '../api';
import { clearSession, useSessionStore } from './session';

const USE_MOCK = import.meta.env.VITE_API_MODE === 'mock';

export function useAuthInit(): void {
  const status = useSessionStore((s) => s.status);
  const setAccount = useSessionStore((s) => s.setAccount);
  const setProjects = useSessionStore((s) => s.setProjects);
  const setStatus = useSessionStore((s) => s.setStatus);

  useEffect(() => {
    if (USE_MOCK || status !== 'loading') return;
    getAccount()
      .then((account) => {
        setAccount(account);
        listProjects()
          .then(setProjects)
          .catch(() => setProjects([]));
      })
      .catch(() => {
        clearSession();
      });
  }, [status, setAccount, setProjects, setStatus]);
}
